import { __assign, __awaiter, __generator } from "tslib";
import { writable } from "svelte/store";
import { ApiClient, pageHandler } from "../GlobalHelper/ApiClient";
var pageStoreHandler = function (pageSelector, campaignWrapperStore, storeUpdateFunction) { return __awaiter(void 0, void 0, void 0, function () {
    var client, page_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = ApiClient.getInstance();
                if (!client) return [3 /*break*/, 2];
                return [4 /*yield*/, client.campaignWrapperClient
                        .listCampaignWrappers(pageHandler(campaignWrapperStore.campaignWrappers, pageSelector))
                        .then(function (result) {
                        return result;
                    })["catch"](function (error) {
                        console.log("error", error);
                        return null;
                    })];
            case 1:
                page_1 = _a.sent();
                storeUpdateFunction(function (store) {
                    return __assign(__assign({}, store), { campaigns: page_1 });
                });
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
function createCampaignStore() {
    var _this = this;
    var _a = writable({
        campaignWrappers: null,
        campaignWrapper: null
    }), subscribe = _a.subscribe, set = _a.set, update = _a.update;
    return {
        subscribe: subscribe,
        update: update,
        getFirstPage: function (campaignWrapperStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("first", campaignWrapperStore, update)];
        }); }); },
        getLastPage: function (campaignWrapperStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("last", campaignWrapperStore, update)];
        }); }); },
        getNextPage: function (campaignWrapperStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("next", campaignWrapperStore, update)];
        }); }); },
        getPrevPage: function (campaignWrapperStore) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler("previous", campaignWrapperStore, update)];
        }); }); },
        getSelfPage: function () { },
        getPageNumbered: function (campaignWrapperStore, pageNumber) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, pageStoreHandler(pageNumber, campaignWrapperStore, update)];
        }); }); },
        setPageSize: function (size) { }
    };
}
export var campaignWrapperStore = createCampaignStore();
